import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03d75e0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notch-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "notch" })
], -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "px-2 pb-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "未出勤のお仕事があります！早急に出勤処理を行ってください", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-weight-bold" }, "緊急連絡先", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-weight-bold mt-4" }, "キャンセルの場合", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "運営事務局へお問い合わせください", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "\n          お仕事終了日から1週間ご連絡がない場合、一時的にアカウントが利用停止となります\n        ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CantUseFeature = _resolveComponent("CantUseFeature")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_BlockBack = _resolveComponent("BlockBack")!
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_AttendanceButton = _resolveComponent("AttendanceButton")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ApplicationsNav = _resolveComponent("ApplicationsNav")!
  const _component_ApplicationsAppliedList = _resolveComponent("ApplicationsAppliedList")!
  const _component_ApplicationsAttendanceList = _resolveComponent("ApplicationsAttendanceList")!
  const _component_ApplicationsNotEvaluatedList = _resolveComponent("ApplicationsNotEvaluatedList")!
  const _component_ApplicationsClosedList = _resolveComponent("ApplicationsClosedList")!
  const _component_NotStartWorkModal = _resolveComponent("NotStartWorkModal")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_ApplicationOfficeDetail = _resolveComponent("ApplicationOfficeDetail")!
  const _component_AppButtonOutline = _resolveComponent("AppButtonOutline")!
  const _component_BModal = _resolveComponent("BModal")!
  const _component_ConfirmAttendanceCorrectionRequiredModal = _resolveComponent("ConfirmAttendanceCorrectionRequiredModal")!
  const _component_ConfirmDiscrepancyTimeModal = _resolveComponent("ConfirmDiscrepancyTimeModal")!
  const _component_LeavingWorkNeededModal = _resolveComponent("LeavingWorkNeededModal")!
  const _component_LeavingWorkNeededWithAttendanceCorrectionModal = _resolveComponent("LeavingWorkNeededWithAttendanceCorrectionModal")!
  const _component_NotAttendedModal = _resolveComponent("NotAttendedModal")!

  return (_ctx.initialized && !_ctx.canApplyOrHasApplications)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createVNode(_component_CantUseFeature),
        _createTextVNode(),
        _createVNode(_component_AppFooter),
        _createTextVNode(),
        _createVNode(_component_BlockBack)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_Header, { ref: "header" }, {
          right: _withCtx(() => [
            _createElementVNode("a", {
              href: _ctx.externalLink.attendance
            }, [
              _createVNode(_component_FeatherIcon, {
                icon: "help-circle",
                size: "1x",
                class: "text-gray-05 mr-2"
              })
            ], 8, _hoisted_4),
            _createTextVNode(),
            (_ctx.doingApplication || _ctx.mostRecentAppliedApplication)
              ? (_openBlock(), _createBlock(_component_AttendanceButton, {
                  key: "enableButton",
                  isAttendance: !!_ctx.doingApplication,
                  onClickAttendance: _ctx.checkAttendanceTime
                }, null, 8, ["isAttendance", "onClickAttendance"]))
              : (_openBlock(), _createBlock(_component_AttendanceButton, {
                  key: "disableButton",
                  isDisabled: ""
                }))
          ]),
          default: _withCtx(() => [
            _createTextVNode("\n      仕事管理\n      ")
          ], undefined, true),
          _: 1
        }, 512),
        _createTextVNode(),
        _createVNode(_component_ApplicationsNav, { links: _ctx.applicationNavItems }, null, 8, ["links"]),
        _createTextVNode(),
        (_ctx.initializedApplications)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.isAppliedPage)
                ? (_openBlock(), _createBlock(_component_ApplicationsAppliedList, {
                    key: 0,
                    onClickOrderCard: _ctx.goToApplicationsDetail
                  }, null, 8, ["onClickOrderCard"]))
                : (_ctx.isAttendancePage)
                  ? (_openBlock(), _createBlock(_component_ApplicationsAttendanceList, {
                      key: 1,
                      onClickOrderCard: _ctx.goToApplicationsDetail
                    }, null, 8, ["onClickOrderCard"]))
                  : (_ctx.isNotEvaluatedPage)
                    ? (_openBlock(), _createBlock(_component_ApplicationsNotEvaluatedList, {
                        key: 2,
                        onClickOrderCard: _ctx.goToApplicationsDetail
                      }, null, 8, ["onClickOrderCard"]))
                    : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createTextVNode(),
        (_ctx.isEvaluatedPage || _ctx.isCanceledPage)
          ? (_openBlock(), _createBlock(_component_ApplicationsClosedList, {
              key: 1,
              onClickOrderCard: _ctx.goToApplicationsDetail
            }, null, 8, ["onClickOrderCard"]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createVNode(_component_AppFooter),
        _createTextVNode(),
        _createVNode(_component_BlockBack),
        _createTextVNode(),
        (_ctx.mostRecentAppliedApplication)
          ? (_openBlock(), _createBlock(_component_NotStartWorkModal, {
              key: 2,
              visible: _ctx.isShownNotStartWorkModal,
              application: _ctx.mostRecentAppliedApplication,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShownNotStartWorkModal = false))
            }, null, 8, ["visible", "application"]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createVNode(_component_BModal, {
          modelValue: _ctx.isShownAttendNeededModal,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isShownAttendNeededModal) = $event)),
          "hide-header": "",
          "hide-footer": "",
          "no-close-on-backdrop": "",
          "no-close-on-esc": "",
          centered: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createTextVNode(),
              _createVNode(_component_AppButton, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToAttendancePage(false))),
                block: true,
                class: "d-block mb-3 mt-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("\n          出勤する\n        ")
                ], undefined, true),
                _: 1
              }),
              _createTextVNode(),
              _hoisted_7,
              _createTextVNode(),
              (_ctx.firstNotAttendedAndCorrectedApplication)
                ? (_openBlock(), _createBlock(_component_ApplicationOfficeDetail, {
                    key: 0,
                    office: _ctx.firstNotAttendedAndCorrectedApplication.order.office
                  }, null, 8, ["office"]))
                : _createCommentVNode("", true),
              _createTextVNode(),
              _hoisted_8,
              _createTextVNode(),
              _hoisted_9,
              _createTextVNode(),
              _createVNode(_component_AppButtonOutline, {
                href: _ctx.externalLink.contact,
                size: "small",
                block: "",
                class: "mb-3 mt-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("\n          お問い合わせフォーム\n        ")
                ], undefined, true),
                _: 1
              }, 8, ["href"]),
              _createTextVNode(),
              _hoisted_10
            ])
          ], undefined, true),
          _: 1
        }, 8, ["modelValue"]),
        _createTextVNode(),
        (_ctx.doingApplication)
          ? (_openBlock(), _createBlock(_component_ConfirmAttendanceCorrectionRequiredModal, {
              key: 3,
              visible: _ctx.isShownConfirmAttendanceCorrectionRequiredModal,
              application: _ctx.doingApplication,
              onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShownConfirmAttendanceCorrectionRequiredModal = false)),
              onFinishWork: _ctx.finishWork
            }, null, 8, ["visible", "application", "onFinishWork"]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        (_ctx.doingApplication)
          ? (_openBlock(), _createBlock(_component_ConfirmDiscrepancyTimeModal, {
              key: 4,
              visible: _ctx.isShownConfirmDiscrepancyTimeModal,
              application: _ctx.doingApplication,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShownConfirmDiscrepancyTimeModal = false)),
              onFinishWork: _ctx.finishWork
            }, null, 8, ["visible", "application", "onFinishWork"]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        (_ctx.doingApplication)
          ? (_openBlock(), _createBlock(_component_LeavingWorkNeededModal, {
              key: 5,
              visible: _ctx.isShownLeavingWorkNeededModal,
              application: _ctx.doingApplication,
              onFinishWork: _ctx.finishWork
            }, null, 8, ["visible", "application", "onFinishWork"]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        (_ctx.doingApplication)
          ? (_openBlock(), _createBlock(_component_LeavingWorkNeededWithAttendanceCorrectionModal, {
              key: 6,
              visible: _ctx.isShownLeavingWorkNeededWithAttendanceCorrectionModal,
              application: _ctx.doingApplication,
              onFinishWork: _ctx.finishWork
            }, null, 8, ["visible", "application", "onFinishWork"]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        (_ctx.firstNotAttendedAndCorrectedApplication)
          ? (_openBlock(), _createBlock(_component_NotAttendedModal, {
              key: 7,
              visible: _ctx.isShownNotAttendedModal,
              application: _ctx.firstNotAttendedAndCorrectedApplication
            }, null, 8, ["visible", "application"]))
          : _createCommentVNode("", true)
      ]))
}